"use strict";
const Config = {
  appTitle: "Anna Miller Architekci",
  appTitleShort: "AMA",
  appDescription: "Anna Miller Architekci",
  appThemeColor: "#00dcdc",
  appBgColor: "#ffffff",
  appIcon: "assets/app-icon.png",
  wpDomain: "https://ama.annamiller-architekci.pl/",
  client: "https://ama.annamiller-architekci.pl/",
  loadDbName: "vwpLocal",
  analyticsPath: "//www.google-analytics.com/analytics.js",
};

module.exports = Config;
